import {
  Button,
  Center,
  Flex,
  Modal,
  ScrollArea,
  Text,
  Divider,
  Space,
} from "@mantine/core";
import type { FC } from "react";
import { NotificationMessage } from "src/component/pageComponent/Notification/NotificationList/NotificationMessage";
import type { NotificationUserItem } from "src/service/NotificationUserApi/type";

import styles from "./NotificationListModal.module.scss";

export const NotificationMessageModal: FC<{
  item?: NotificationUserItem | null;
  opened: boolean;
  onClose: () => void;
}> = ({ item, opened, onClose }) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      padding={10}
      radius={12}
      overlayOpacity={0.5}
    >
      <Text className={styles.modalHeader}>お知らせ</Text>
      <Divider />
      <ScrollArea style={{ maxHeight: "80vh" }}>
        {item && (
          <Center sx={{ minHeight: 100, paddingBottom: 20, paddingTop: 20 }}>
            <NotificationMessage notification={item} showAll />
          </Center>
        )}
      </ScrollArea>
      <Divider />
      <Space h={10} />
      <Flex align="center" w="100%" gap={8} justify="center">
        <Button className={styles.modalBackButton} onClick={onClose}>
          戻る
        </Button>
      </Flex>
    </Modal>
  );
};
